import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full bg-black overflow-hidden" data-id="element-165">
      {/* Cinematic red glow backdrop */}
      <div className="absolute inset-0 z-0" data-id="element-166">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-red-700/20 blur-[140px]" data-id="element-167" />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/40 to-black" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.6) 70%, #000 100%)'
      }} data-id="element-168" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-169" />

      {/* Premium Warning Bar */}
      <div className="relative z-20 w-full bg-[#0a0a0a]/80 backdrop-blur-md border-b border-red-900/50 py-3 text-center shadow-[0_0_20px_rgba(220,38,38,0.15)]" data-id="element-170">
        <p className="text-white text-sm md:text-base font-semibold tracking-wide flex items-center justify-center gap-2 pt-[02px] pb-[02px]" data-id="element-171">
          ⚠️Si sientes que algo cambió en tu rendimiento..
        </p>
      </div>

      {/* Hero Content */}
      <div className="relative z-20 max-w-3xl mx-auto px-6 py-10 md:py-16" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-173">
          <div className="relative mb-8" data-id="element-174">
            <div className="absolute inset-0 blur-3xl bg-red-600/20 -z-10" data-id="element-175" />
            <h1 className="font-display text-6xl md:text-8xl lg:text-9xl uppercase text-center leading-[0.95] tracking-tight" data-id="element-176">
              <span className="block text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.3)] text-[48px]" data-id="element-177">
                Recupera tu
              </span>
              <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-b from-red-500 to-red-700 drop-shadow-[0_0_30px_rgba(220,38,38,0.8)] text-[72px]" data-id="element-178">
                PODER EN LA INTIMIDAD
              </span>
            </h1>
          </div>

          <p className="text-lg md:text-2xl text-center text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-179">
            El sistema completo para hombres que quieren eliminar{' '}
            <span className="text-white font-semibold drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-180">
              ansiedad sexual, eyaculación precoz o pérdida de erección
            </span>{' '}
            y quieren recuperar el control de su cuerpo y{' '}
            <span className="text-white font-semibold drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-181">
              más seguridad en la intimidad
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}